import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import GlobalButton from "../../../shared/utils/GlobalButton";

const RejectModal = ({
  open,
  onClose,
  onConfirm,
  title = "Reject Item",
  isProcessing = false,
  confirmButtonText = "Reject",
  cancelButtonText = "Cancel",
  placeholder = "Enter rejection reason...",
  rows = 4,
  itemName = null,
  itemCount = null,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [localProcessing, setLocalProcessing] = useState(false);

  useEffect(() => {
    if (!open) {
      setReason("");
      setError("");
      setLocalProcessing(false);
    }
  }, [open]);

  useEffect(() => {
    if (!isProcessing) {
      setLocalProcessing(false);
    }
  }, [isProcessing]);

  const handleConfirm = () => {
    const trimmedReason = reason.trim();
    if (!trimmedReason) {
      setError("Please provide a rejection reason");
      return;
    }
    setError("");
    setLocalProcessing(true);
    onConfirm(trimmedReason);
  };

  const handleClose = () => {
    setReason("");
    setError("");
    setLocalProcessing(false);
    onClose();
  };

  const isDisabled = !reason.trim() || localProcessing || isProcessing;
  const showProcessing = localProcessing || isProcessing;

  // Get display text for item info
  const getItemDisplayText = () => {
    if (itemCount && itemCount > 1) {
      return `${itemCount} items`;
    }
    if (itemName) {
      return itemName;
    }
    return null;
  };

  const itemDisplayText = getItemDisplayText();

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6">
          {title}
          {itemDisplayText && ` - ${itemDisplayText}`}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <label className="my-2 block">Rejection Reason:</label>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={rows}
          placeholder={placeholder}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError("");
          }}
          error={!!error}
          helperText={error}
          disabled={showProcessing}
        />
      </DialogContent>

      <DialogActions>
        <GlobalButton
          onClick={handleClose}
          disabled={showProcessing}
          variant="secondary"
        >
          {cancelButtonText}
        </GlobalButton>
        <GlobalButton
          variant="warning"
          onClick={handleConfirm}
          disabled={isDisabled}
          isLoading={showProcessing}
        >
          {confirmButtonText}
        </GlobalButton>
      </DialogActions>
    </Dialog>
  );
};

export default RejectModal;
